import { useMemo } from 'react';
import { decideChartPointInterval } from 'utils/datetime';

import { getApiInterval } from 'utils/pql';

import { SEARCH_TYPE } from './consts';
import useCurrentDashboardSearch from './useCurrentDashboardSearch';

export default function useTimeChartData() {
  const { t1, t2, page } = useCurrentDashboardSearch();

  const tDiff = t1 && t2 ? Math.abs(t1 - t2) : null;
  const pointInterval = useMemo(() => decideChartPointInterval(page, tDiff), [page, tDiff]);
  const apiInterval = getApiInterval(t1, t2, SEARCH_TYPE[page], pointInterval);

  return { apiInterval, pointInterval };
}
